import React from "react";
import styled from "styled-components";
import { COLORS } from "@/react/theme/constants";

const ButtonLabel = styled.div`
  display: flex;
  gap: 4px;
  text-align: center;
  align-items: center;
  padding: 8px;
`;

const ButtonBlock = styled.div`
  font-size: 15px;
  width: min-content;
  cursor: pointer;
  border: 1px solid ${COLORS.secondary};
  border-radius: 50rem;
  :hover {
    background-color: ${COLORS.tertiary};
  }
`;

export const CustomButton = (props) => {
  return (
    <ButtonBlock onClick={() => props.onClick()}>
      <ButtonLabel>{props.children}</ButtonLabel>
    </ButtonBlock>
  );
};
